/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Damages_Actions_AriaInputs */

const en_case_damages_actions_aria = /** @type {(inputs: Case_Damages_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open value actions`)
};

const pt_br2_case_damages_actions_aria = /** @type {(inputs: Case_Damages_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir ações do valor`)
};

/**
* | output |
* | --- |
* | "Open value actions" |
*
* @param {Case_Damages_Actions_AriaInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_damages_actions_aria = /** @type {((inputs?: Case_Damages_Actions_AriaInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Damages_Actions_AriaInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_damages_actions_aria(inputs)
	return pt_br2_case_damages_actions_aria(inputs)
});